export class RwandaLocationParser {
  private LocationData: Record<string, object> = {}; // To hold the fetched data

  /**
   * Fetch all data from the JSON file and store it locally.
   */
  async getLocationData(): Promise<Record<string, object>> {
    const url =
      "https://kivunova.s3.us-east-1.amazonaws.com/rwandaLocationData.json";

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      this.LocationData = responseData;
      return responseData;
    } catch (error) {
      /* eslint-disable no-console */
      console.error("Error fetching data:", error);
      return this.LocationData;
    }
  }

  /**
   * Get all provinces.
   */
  getProvinces(locationData?: Record<string, object>): string[] {
    try {
      return Object.keys(locationData || this.LocationData);
    } catch (e) {
      /* eslint-disable no-console */
      console.error("Data not loaded. Call getAllData() first.", e);
      return [];
    }
  }

  /**
   * Get districts in a province.
   */
  getDistrictByProvince(
    province: string,
    locationData?: Record<string, object>
  ): string[] {
    try {
      console.log("getting provinces", locationData, province);
      const data = locationData
        ? locationData[province]
        : this.LocationData[province];
      return Object.keys(data);
    } catch (error) {
      /* eslint-disable no-console */
      console.error(
        `Error getting districts for province "${province}":`,
        error
      );
      return [];
    }
  }

  /**
   * Get districts in a province.
   */
  getAllDistricts(locationData?: Record<string, object>): string[] {
    try {
      // Reduce all provinces into a combined list of districts
      return Object.keys(locationData || this.LocationData).reduce(
        (districts: string[], province: string) => {
          const provinceDistricts = Object.keys(this.LocationData[province]);
          return [...districts, ...provinceDistricts];
        },
        []
      );
    } catch (error) {
      /* eslint-disable no-console */
      console.error("Error getting all districts:", error);
      return [];
    }
  }

  /**
   * Get sectors in a district of a province.
   */
  getSectors(
    province: string,
    district: string,
    locationData?: Record<string, object>
  ): string[] {
    try {
      const data = locationData
        ? locationData[province][district]
        : this.LocationData[province][district];
      return Object.keys(data);
    } catch (error) {
      /* eslint-disable no-console */
      console.error(
        `Error getting sectors for district "${district}" in province "${province}":`,
        error
      );
      return [];
    }
  }

  /**
   * Get cells in a sector of a district and province.
   */
  getCells(
    province: string,
    district: string,
    sector: string,
    locationData?: Record<string, object>
  ): string[] {
    try {
      const data = locationData
        ? locationData[province][district][sector]
        : this.LocationData[province][district][sector];
      return Object.keys(data);
    } catch (error) {
      /* eslint-disable no-console */
      console.error(
        `Error getting cells for sector "${sector}" in district "${district}" and province "${province}":`,
        error
      );
      return [];
    }
  }

  /**
   * Get villages in a cell of a sector, district, and province.
   */
  getVillages(
    province: string,
    district: string,
    sector: string,
    cell: string,
    locationData?: Record<string, object>
  ): string[] {
    try {
      const data = locationData
        ? locationData[province][district][sector][cell]
        : this.LocationData[province][district][sector][cell];
      return data;
    } catch (error) {
      /* eslint-disable no-console */
      console.error(
        `Error getting villages for cell "${cell}" in sector "${sector}", district "${district}", and province "${province}":`,
        error
      );
      return [];
    }
  }
}
